<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chibernsteinsubjects0007#acknow">Acknowledgments</a></p>
<p class="toc"><a class="xref" href="#/chibernsteinsubjects0008#ch01"><b>1</b>  Tracing the “Traffic in Women”</a></p>
<p class="toc"><a class="xref" href="#/chibernsteinsubjects0009#ch02"><b>2</b>  The Sexual Politics of Carceral Feminism</a></p>
<p class="toc"><a class="xref" href="#/chibernsteinsubjects0010#ch03"><b>3</b>  Seek Justice™</a></p>
<p class="toc"><a class="xref" href="#/chibernsteinsubjects0011#ch04"><b>4</b>  The Travels of Trafficking</a></p>
<p class="tocau">with Elena Shih</p>
<p class="toc"><a class="xref" href="#/chibernsteinsubjects0012#ch05"><b>5</b>  Redemptive Capitalism and Sexual Investability</a></p>
<p class="toc"><a class="xref" href="#/chibernsteinsubjects0013#ch06"><b>6</b>  Imagining Freedom</a></p>
<p class="toc"><a class="xref" href="#/chibernsteinsubjects0014#aft">Afterword</a></p>
<p class="tocbmf"><a class="xref" href="#/chibernsteinsubjects0015#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chibernsteinsubjects0016#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chibernsteinsubjects0017#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bernstein-subjects-0006.vue?fc303ada